import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { configEndpoint, reportEndPoint } from 'src/app/utils/constants/requestUrl';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  getReportHeaders(value) {
    const reqBody = {
      config_queries: [
        {
          config_id: value,
        },
      ],
    };
    return this.http.post(`${environment.configUrl}${configEndpoint.getConfiguration}`, reqBody);
  }

  getReports(data): Observable<any> {
    return this.http.post(`${environment.mawbUrl}${reportEndPoint.getReport}`, data);
  }
}
